const zeroParticipationReasons = [
    {
        "id": 11,
        "name": "ΝΕΟΠΛΑΣΜΑΤΑ-ΛΕΥΧΑΙΜΙΕΣ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 12,
        "name": "ΣΑΚΧΑΡΩΔΗΣ ΔΙΑΒΗΤΗΣ ΤΥΠΟΥ Ι",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 13,
        "name": "ΨΥΧΩΣΕΙΣ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 14,
        "name": "ΕΠΙΛΗΨΙΑ ΚΑΙ ΛΟΙΠΕΣ ΕΠΙΛΗΠΤΙΚΕΣ ΚΑΤΑΣΤΑΣΕΙΣ",
        "active": false,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 15,
        "name": "ΙΔΙΟΠΑΘΗΣ ΑΙΜΟΛΥΤΙΚΗ ΑΝΑΙΜΙΑ-ΘΡΟΜΒΟΠΕΝΙΚΗ ΠΟΡΦΥΡΑ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 16,
        "name": "ΝΥΧΤΕΡΙΝΗ ΠΑΡΟΞΥΣΜΙΚΗ ΑΙΜΟΣΦΑΙΡΙΝΟΥΡΙΑ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 17,
        "name": "ΑΙΜΟΡΡΟΦΙΛΙΑ (ΑΝΤΙΑΙΜΟΡΡΟΦΙΛΙΚΟΙ ΠΑΡΑΓΟΝΤΕΣ)",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 18,
        "name": "ΥΠΟΦΥΣΙΟΓΕΝΗΣ ΝΑΝΙΣΜΟΣ (ΑΥΞΗΤΙΚΗ ΟΡΜΟΝΗ)",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 19,
        "name": "ΚΥΣΤΙΚΗ ΙΝΩΣΗ (ΚΥΣΤΙΚΗ ΙΝΩΔΗΣ/ΙΝΟΚΥΣΤΙΚΗ ΝΟΣΟΣ)",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 20,
        "name": "ΑΓΓΕΙΟΠΑΘΕΙΑ BURGER",
        "active": false,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 21,
        "name": "ΑΝΟΙΑ, ΝΟΣΟΣ ALZHEIMER ΚΑΙ ΝΟΣΟΣ CHARCOT",
        "active": false,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 22,
        "name": "ΧΡΟΝΙΑ ΗΠΑΤΙΤΙΔΑ B ΚΑΙ C",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 23,
        "name": "ΝΟΣΟΣ WILSON (ΗΠΑΤΟΦΑΚΟΕΙΔΗΣ ΕΚΦΥΛΙΣΗ)",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 24,
        "name": "ΓΛΥΚΟΓΟΝΙΑΣΗ - ΓΛΥΚΟΓΟΝΙΑΣΗ ΤΥΠΟΥ ΙΒ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 25,
        "name": "ΝΟΣΟΣ GAUCHER",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 26,
        "name": "ΕΛΛΕΙΨΗ ΟΡΝΙΘΟ-ΚΑΡΒΑΜΥΛΟ-ΤΡΑΝΣΦΕΡΑΣΗΣ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 27,
        "name": "ΠΝΕΥΜΟΝΙΚΗ ΥΠΕΡΤΑΣΗ",
        "active": false,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 28,
        "name": "ΧΡΟΝΙΑ ΝΕΦΡΙΚΗ ΝΟΣΟΣ, ΣΤΑΔΙΟ 3 ΚΑΙ 4",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 29,
        "name": "ΝΟΣΟΣ NIEMANN-PICK ΤΥΠΟΥ C",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 30,
        "name": "ΥΠΕΡΦΑΙΝΥΛΑΛΑΝΙΝΑΙΜΙΑ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 9,
        "name": "ΜΕΣΟΓΕΙΑΚΗ ΑΝΑΙΜΙΑ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 10,
        "name": "ΔΡΕΠΑΝΟΚΥΤΤΑΡΙΚΗ ΑΝΑΙΜΙΑ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 31,
        "name": "ΤΕΛ. ΣΤΑΔ. ΧΡΟΝ. ΝΕΦΡΙΚΗΣ ΝΟΣΟΥ ΕΞΩΝΕΦΡΙΚΗ ΚΑΘΑΡΣΗ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 33,
        "name": "ΤΥΠΕΤ - ΑΜΕΑ ΑΝΩ ΤΩΝ 32 ΕΤΩΝ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 4,
        "name": "ΜΕΤΑΜΟΣΧΕΥΜΕΝΟΙ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 5,
        "name": "ΝΕΦΡΟΠΑΘΕΙΣ ΣΕ ΑΙΜΟΚΑΘΑΡΣΗ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 6,
        "name": "ΠΑΡΑΠΛΗΓΙΚΟΙ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 7,
        "name": "ΣΚΛΗΡΥΝΣΗ ΚΑΤΑ ΠΛΑΚΑΣ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 8,
        "name": "ΤΕΤΡΑΠΛΗΓΙΚΟΙ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    },
    {
        "id": 32,
        "name": "ΚΥΗΣΗ ΚΑΙ ΛΟΧΕΙΑ",
        "active": true,
        "filterMedicine": false,
        "consumable": false
    }
]

export const getZeroParticipationReasonOptions = () => {
    let arr = [];
    for (let obj of zeroParticipationReasons.filter((el) => el["active"] === "true")) {
        arr.push({
            label: String(obj["name"]),
            value: String(obj["id"]),
        })
    }
    arr.sort((a, b) => String(a.label).localeCompare(b.label, "el"));
    return [{value: "", label: "Κενό"}, ...arr];
}

const zeroReferralParticipationReasons = [
    {
        "id": 1,
        "noParticipationCase": "ΜΕΣΟΓΕΙΑΚΗ ΑΝΑΙΜΙΑ",
        "isActive": true,
        "needsDecision": false
    },
    {
        "id": 2,
        "noParticipationCase": "ΔΡΕΠΑΝΟΚΥΤΤΑΡΙΚΗ ΝΟΣΟΣ",
        "isActive": true,
        "needsDecision": false
    },
    {
        "id": 8,
        "noParticipationCase": "ΚΛΗΡΟΝΟΜΙΚΗ ΣΙΔΗΡΟΒΛΑΣΤΙΚΗ ΑΝΑΙΜΙΑ",
        "isActive": true,
        "needsDecision": false
    },
    {
        "id": 3,
        "noParticipationCase": "ΧΡΟΝΙΑ ΝΕΦΡΙΚΗ ΑΝΕΠΑΡΚΕΙΑ ΤΕΛΙΚΟΥ ΣΤΑΔΙΟΥ (ΣΕ ΘΕΡΑΠΕΙΑ ΥΠΟΚΑΤΑΣΤΑΣΗΣ ΝΕΦΡΙΚΗΣ ΛΕΙΤΟΥΡΓΙΑΣ Ή ΠΕΡΙΤΟΝΑΙΚΗ ΚΑΘΑΡΣΗ Ή ΜΕ ΜΕΤΑΜΟΣΧΕΥΣΗ)",
        "isActive": true,
        "needsDecision": false
    },
    {
        "id": 4,
        "noParticipationCase": "ΚΥΣΤΙΚΗ ΙΝΩΣΗ",
        "isActive": true,
        "needsDecision": false
    },
    {
        "id": 5,
        "noParticipationCase": "ΣΑΚΧΑΡΩΔΗΣ ΔΙΑΒΗΤΗΣ ΤΥΠΟΥ 1",
        "isActive": true,
        "needsDecision": false
    },
    {
        "id": 6,
        "noParticipationCase": "ΑΚΡΩΤΗΡΙΑΣΜΕΝΟΙ ΠΟΥ ΛΑΜΒΑΝΟΥΝ ΤΟ ΕΞΩΙΔΡΥΜΑΤΙΚΟ ΕΠΙΔΟΜΑ ΜΕ ΠΟΣΟΣΤΟ ΑΝΑΠΗΡΙΑΣ 67% ΚΑΙ ΑΝΩ",
        "isActive": true,
        "needsDecision": true
    },
    {
        "id": 7,
        "noParticipationCase": "ΠΙΣΤΟΠΟΙΗΜΕΝΗ ΑΝΑΠΗΡΙΑ 80% ΚΑΙ ΑΝΩ ΑΠΟ ΚΕΠΑ Ή ΑΛΛΕΣ ΥΓΕΙΟΝΟΜΙΚΕΣ ΕΠΙΤΡΟΠΕΣ",
        "isActive": true,
        "needsDecision": true
    }
]

export const getZeroReferralParticipationReasonsOptions = () => {
    let arr = [];
    for (let obj of zeroReferralParticipationReasons.filter((el) => el["isActive"] === "true")) {
        arr.push({
            label: String(obj["noParticipationCase"]),
            value: String(obj["id"]),
            needsDecision: String(obj["needsDecision"]),
        })
    }
    arr.sort((a, b) => String(a.label).localeCompare(b.label, "el"));
    return [{value: "", label: "Κενό"}, ...arr];
}
